import React from 'react'
import healthcare1 from '../images/coresync1.png';
import healthcare2 from '../images/coresync2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function CoreSyncErp() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading"><span className="highlight-orange">CoreSync ERP </span> - AI Patent Research Software
                    </div>
                </div>
            </section>
            <section className="container my-5">
                {/* Healthcare Information Systems */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Healthcare Information Systems"
                            className="img-fluid w-100 h-100 object-fit-cover" />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">CoreSync </span> ERP
                        </h1>
                        <p className="mb-4">
                            <h4>is designed to reshape the landscape of web development by providing businesses with highly customized, scalable, and AI-powered solutions. Our platform focuses on building dynamic, interactive web applications tailored to specific business needs, enhancing both user engagement and business performance.
                                <br />
                                This system leverages advanced AI algorithms and tools to streamline the web development process, enabling developers to build web applications faster and with greater precision, while ensuring seamless integration with existing business systems.</h4>
                        </p>

                        <h6 className="fw-bold mb-2 highlight-orange">Key Highlight:</h6>
                        <p className="mb-4 ps-3">
                            <h5>Revolutionizing Enterprise Resource Planning with AI CoreSync ERP is a powerful platform designed to streamline business processes, improve operational efficiency, and empower businesses to make data-driven decisions. With AI-powered insights and automation, CoreSync ERP helps organizations optimize their resources, reduce costs, and improve overall productivity. Whether you're managing finance, supply chain, HR, or customer relations, CoreSync ERP integrates all key aspects of your business into one cohesive system, ensuring smoother workflows and better communication across departments. Upload business data, reports, or documents, and let our advanced AI algorithms analyze and provide instant recommendations tailored to your business needs. Our cutting-edge models help identify trends, optimize operations, and improve decision-making processes with actionable insights.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Telemedicine & Remote Patient Monitoring */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> A Global Intellectual Property Firm
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">USA</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Project Scope & Technology</h4>
                        <p className="mb-3 ps-3">
                            CoreSync ERP, AI-Powered Patent Research, OpenAI, Pinecone, LangChain, ReactJS, MongoDB, Node.js
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Industry</h4>
                        <p className="mb-3 ps-3">LegalTech / Intellectual Property</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Composition</h4>
                        <p className="mb-3 ps-3">
                            1 UI/UX Designer, 2 Frontend Developers, 2 Backend Developers, 1 Quality Analyst,
                            1 Business Analyst, 2 AI Developers
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Work Duration</h4>
                        <p className="mb-4 ps-3">4 Months</p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Telemedicine and Remote Patient Monitoring"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>


                {/* Hospital Management & Workflow Automation */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="AI-Driven ERP Process"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            Our team of AI specialists and developers worked diligently to build CoreSync ERP’s platform,
                            utilizing advanced machine learning algorithms to automate and accelerate custom web development.
                            The focus was on ensuring scalability, flexibility, and efficiency in the design and deployment of web applications.
                        </p>

                        <p className="mb-3 ps-1">
                            Through natural language processing (NLP) and generative AI, we enabled the platform to understand project
                            requirements more intuitively, automatically suggesting design solutions and code optimizations based on client needs.
                        </p>

                        <p className="mb-3 ps-1">
                            Our development process focused on building a user-friendly interface for easy integration with existing
                            business processes, ensuring that the platform could be adapted to a wide range of web development projects.
                        </p>

                        <p className="mb-4 ps-1">
                            The goal was to empower businesses to create custom web applications quickly and cost-effectively,
                            all while maintaining high standards of quality and performance.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">Agentic AI-based scraping of patent data from multiple websites using FireCrawler</li>
                            <li className="mb-1">Gen AI-based patent text analysis</li>
                            <li className="mb-1">Identifying and suggesting alternative formulations that could bypass existing patents</li>
                            <li className="mb-1">IPC/CPC code lookup</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />

            </section></>
    )
}

export default CoreSyncErp